import React from 'react';
import { Button } from '@components/Button';
import {
  WrapperBox,
  Heading,
  StyledBox,
  StyledTextPairing,
  AssetsWrapperBox,
  AssetsBox,
  AssetsBoxSecond,
  AssetsBoxArts,
  AssetsCloudImage,
  LeftBackgroundYellow,
  BackgroundYellowWrapper,
  ForegroundAssetsBox,
} from './HorizontalAnimation.styles';

interface Assets {
  width: number;
  offset: number;
  src: string;
  top?: number;
  zIndex?: number;
  resWidth: number;
  resOffset?: number;
  resTop?: number;
  isLeft?: boolean;
  isCircle?: boolean;
  isRadius?: boolean;
}

export interface HorizontalAnimation {
  eyebrow: string;
  title: string;
  body: string;
  cta: string;
  ctaId: string;
  ctaLink: string;
  paddingTop?: [number, number];
  paddingBottom?: [number, number];
  animation: {
    width: number;
    resWidth: number;
    letBackground: string;
    backgroundAssets: Array<Assets>;
    assets: Array<Assets>;
    foregroundAssets: Array<Assets>;
  };
}

export const HorizontalAnimation: React.FC<HorizontalAnimation> = props => {
  const { eyebrow, title, body, cta, ctaId, ctaLink, paddingBottom, paddingTop } = props;
  const { width, resWidth, letBackground, backgroundAssets, assets, foregroundAssets } = props.animation;
  return (
    <WrapperBox paddingBottom={paddingBottom} paddingTop={paddingTop}>
      <Heading paddingX={7}>
        <StyledTextPairing
          eyebrow={eyebrow}
          eyebrowVariant="sectionEyeBrow24"
          eyebrowColor={'humana5'}
          eyebrowTagName="h3"
          title={title}
          titleVariant="hed56"
          titleColor={'neutra6'}
          titleTagName="h2"
          body={body}
          bodyVariant="dek20"
          bodyColor={'neutra5'}
          textAlign="center"
          alignment={'center'}
        />
      </Heading>
      <StyledBox marginTop={[7, 6]}>
        <Button id={`${ctaId}ExploreCareers`} variant="secondary" forwardedAs="a" href={ctaLink}>
          {cta}
        </Button>
      </StyledBox>
      <AssetsWrapperBox paddingTop={[11, 12]}>
        <AssetsBoxArts>
          {backgroundAssets.map((backgroundAsset, index) => (
            <AssetsCloudImage
              key={index}
              top={backgroundAsset.top}
              restop={backgroundAsset.resTop}
              width={backgroundAsset.width}
              reswidth={backgroundAsset.resWidth}
              offset={backgroundAsset.offset}
              resoffset={backgroundAsset.resOffset}
              isleft={backgroundAsset.isLeft}
              zindex={backgroundAsset.zIndex}
              src={backgroundAsset.src}
            />
          ))}
        </AssetsBoxArts>
        <AssetsBox width={width} reswidth={resWidth}>
          {assets.map((asset, index) => (
            <AssetsCloudImage
              key={index}
              top={asset.top}
              restop={asset.resTop}
              width={asset.width}
              reswidth={asset.resWidth}
              offset={asset.offset}
              resoffset={asset.resOffset}
              isleft={asset.isLeft}
              iscircle={asset.isCircle}
              isradius={asset.isRadius}
              src={asset.src}
            />
          ))}
        </AssetsBox>
        <AssetsBoxSecond width={width} reswidth={resWidth}>
          {assets.map((asset, index) => (
            <AssetsCloudImage
              key={index}
              top={asset.top}
              restop={asset.resTop}
              width={asset.width}
              reswidth={asset.resWidth}
              offset={asset.offset}
              resoffset={asset.resOffset}
              isleft={asset.isLeft}
              iscircle={asset.isCircle}
              src={asset.src}
            />
          ))}
        </AssetsBoxSecond>
        <ForegroundAssetsBox>
          {foregroundAssets.map((foregroundAsset, index) => (
            <AssetsCloudImage
              key={index}
              top={foregroundAsset.top}
              restop={foregroundAsset.resTop}
              width={foregroundAsset.width}
              reswidth={foregroundAsset.resWidth}
              offset={foregroundAsset.offset}
              resoffset={foregroundAsset.resOffset}
              isleft={foregroundAsset.isLeft}
              iscircle={foregroundAsset.isCircle}
              src={foregroundAsset.src}
            />
          ))}
        </ForegroundAssetsBox>
      </AssetsWrapperBox>
      <BackgroundYellowWrapper>
        <LeftBackgroundYellow src={letBackground} />
      </BackgroundYellowWrapper>
    </WrapperBox>
  );
};
